import type { FaireProductEntity } from "../../entity_types/product";

export const p_m5e6xpffhv: FaireProductEntity = {
  token: "p_m5e6xpffhv",
  type: "product",
  name: "Rosemary & Rice Water Daily Hair Growth Spray 4oz",
  brandToken: "b_3z46kjdoak",
  brandName: "Plant Therapy",
  imageUrl:
    "https://cdn.faire.com/fastly/1d52a8ad5f0a0231ffdfd93a39c0b6ea9965b5a7b9eceb8ccd6d472dccf0da60.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b150e96aa1749458a9a5fdc5bdd41292b0bf03be268a0b5d0e8a1097c8b594e.webp",
    "https://cdn.faire.com/fastly/90d35122f1cc77d4902d9a39c6e818783c1220394a7ac05e3dc706d6978cd6d2.webp",
    "https://cdn.faire.com/fastly/e076f8218f88996cdd1a4c2a37a4b97358ab59dcc163d664010de01cd323c1a8.webp",
    "https://cdn.faire.com/fastly/9303c375426b02508ba9f5691d183fd3194ef7d212b70fd90097745e336cb490.webp",
    "https://cdn.faire.com/fastly/a917870a94480c23faa49de4e7831396ef243efb45a96244a04c244f037a296b.webp",
  ],
  priceDollars: 8,
  description:
    "Give your hair the love it deserves anytime of the day with our Rosemary & Rice Water spray. This comprehensive formula combines traditional, scientifically-backed ingredients with modern hair care technology to enhance your hair's natural beauty while promoting long-term health, repairing damage, and stimulating growth. Lightweight, non-greasy, and effortlessly refreshing, this spray is your go-to hero for taming flyaways, adding volume and shine, repairing damage, or simply spritzing your strands with a burst of hydration and nutrients. Easily incorporate this versatile spray into your daily routine — use it anytime, whether morning, noon, or night. Perfect for a midday refresh or a nourishing treatment before bed, this spray is designed to work around your busy day, leaving your hair feeling healthy, vibrant, and full of life whenever you need it.",
  tags: [],
  msrpDollars: 15.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:05.230Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
